var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVectorShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.926 11.7437H8.92597C7.28556 11.743 5.6762 12.1908 4.27184 13.0386C2.86748 13.8863 1.72157 15.1018 0.957966 16.5537C0.936502 16.2842 0.925827 16.014 0.925966 15.7437C0.925966 10.2207 5.40297 5.74365 10.926 5.74365V0.743652L20.926 8.74365L10.926 16.7437V11.7437Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorShare);
export default __webpack_public_path__ + "static/media/VectorShare.8c336ee77b3765edecf3f6e94fb213f2.svg";
export { ForwardRef as ReactComponent };